(() => {
  'use strict';
  const root = document.querySelector('[data-toasty-quiz]');
  if (!root || root.dataset.quizTrackingReady) return;
  root.dataset.quizTrackingReady = 'true';
  const characters = new Set(['starter', 'herb', 'milk', 'burnt', 'mg']);
  const starts = new Set();
  const completions = new Set();
  const pending = [];
  let privacyLoading = false;
  const permission = () => {
    try {
      const api = window.Shopify?.customerPrivacy;
      return typeof api?.analyticsProcessingAllowed === 'function' ? api.analyticsProcessingAllowed() === true : null;
    } catch (_) { return false; }
  };
  let timer;
  let deadline = 0;
  const send = (name, data) => {
    if (permission() !== true || typeof window.gtag !== 'function') return false;
    const parameters = {
      send_to: 'G-D0E6L2JVXV',
      page_location: 'https://tastytoastys.com' + data.page_path,
      page_title: 'Which Toasty Are You?',
      page_name: 'quiz'
    };
    if (/^[A-Z]{2}$/.test(data.country_code)) parameters.country_code = data.country_code;
    if (characters.has(data.character)) parameters.character = data.character;
    if (data.link_path) parameters.link_path = data.link_path;
    try { window.gtag('event', name, parameters); return true; } catch (_) { return false; }
  };
  const flush = () => {
    timer = undefined;
    const allowed = permission();
    if (allowed === false || Date.now() >= deadline) { pending.length = 0; return; }
    while (pending.length && send(...pending[0])) pending.shift();
    if (pending.length) timer = setTimeout(flush, 100);
  };
  const record = (name, character, linkPath) => {
    const data = {page_path: location.pathname, country_code: root.dataset.quizCountry};
    if (characters.has(character)) data.character = character;
    if (linkPath) data.link_path = linkPath;
    const allowed = permission();
    if (allowed === false) return;
    if (allowed === true && send(name, data)) return;
    if (allowed === null && typeof window.Shopify?.loadFeatures !== 'function') return;
    if (!pending.length) deadline = Date.now() + 10000;
    if (pending.length < 20) pending.push([name, data]);
    if (!timer) timer = setTimeout(flush, 100);
    if (allowed !== null || privacyLoading) return;
    privacyLoading = true;
    try { window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      privacyLoading = false;
      if (error || permission() !== true) pending.length = 0;
    }); } catch (_) { pending.length = 0; privacyLoading = false; }
  };
  root.addEventListener('toasty:quiz-result', event => {
    const {character, run, started} = event.detail || {};
    if (!Number.isInteger(run) || run < 0 || !started) return;
    if (!starts.has(run)) { starts.add(run); record('toasty_quiz_started'); }
    if (characters.has(character) && !completions.has(run)) {
      completions.add(run); record('toasty_quiz_completed', character);
    }
  });
  root.addEventListener('click', event => {
    if (event.defaultPrevented && !event.toastyQuizSaveRequested) return;
    const action = event.target.closest('[data-quiz-shop],[data-quiz-share],[data-quiz-save]');
    const result = action?.closest('[data-quiz-result]');
    if (!result || result.hidden || !characters.has(result.dataset.quizResult)) return;
    if (action.hasAttribute('data-quiz-shop')) {
      let path;
      try { const url = new URL(action.href, location.origin); if (url.origin !== location.origin) return; path = url.pathname; } catch (_) { return; }
      record('toasty_quiz_shop_clicked', result.dataset.quizResult, path);
    } else if (action.hasAttribute('data-quiz-share')) {
      record('toasty_quiz_share_clicked', result.dataset.quizResult);
    } else {
      record('toasty_quiz_save_clicked', result.dataset.quizResult);
    }
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (permission() !== true) { pending.length = 0; clearTimeout(timer); timer = undefined; }
  });
})();
